<template>

<app-content :loading="is.loading">

	<app-content-head :title="title" :back="$route.meta.back" :readonly="$authorised('mem/pricing/access', 'read')">

		<app-content-head-actions-item v-if="!isNew" icon="preview" text="View" :url="joinURL + '/' + item.url" />
		<app-content-head-actions-item :divide="!isNew" :disabled="!isDirty" icon="undo" text="Undo" v-on:click="onUndoClick" />
		<app-content-head-actions-item :loading="is.saving" :disabled="!isDirty || !isValid" icon="save" text="Save" v-on:click="onSaveClick" />
		<app-content-head-actions-item v-if="!isNew && !model.default" :disabled="isNew" :danger="true" icon="delete" text="Delete" v-on:click="onDeleteClick" />

	</app-content-head>

	<app-content-body>

		<app-content-box :readonly="$authorised('mem/pricing/access', 'read')">

			<app-input-text label="Name" :maxlength="32" placeholder="Enter name..." v-model="model.name" :validation="$v.model.name" />
			
            <app-input-checklist :collapsed="!isNew" :fullWidth="true" :singular="true" :columns="1" label="Default" v-model="model.default" :validation="$v.model.default" :options="$constants.membership.onboarding.defaultName" :descriptions="$constants.membership.onboarding.defaultDescription" />
			
            <app-input-checklist  v-if="!model.default" :collapsed="!isNew" :fullWidth="true" :singular="true" :columns="1" label="Status" v-model="model.status" :validation="$v.model.type" :options="$constants.membership.onboarding.statusName" :descriptions="$constants.membership.onboarding.statusDescription" />
			
            <app-input-text v-if="!model.default && !isNew" label="URL" :textPrefix="prefixURL" v-model="model.slug" :validation="$v.model.slug" />
            
            <app-input-toggle :toggle="model.plans.enabled" v-on:toggle="model.plans.enabled = !model.plans.enabled" label="Plans" :column="true" :asString="true" :multiple="true" v-model="model.plans.available" :validation="$v.model.plans.available" :options="references.plans" notes="You can restrict the plans available on the landing page." />
			
		</app-content-box>

	</app-content-body>

</app-content>

</template>

<script>

import mixForm from '@/mixin/form'
import { required } from 'vuelidate/lib/validators'

export default {

	mixins: [mixForm],

	data: function() {

		return {
			readonly: this.$authorised('mem/pricing/access', 'read'),
			references: {
                plans: []
            },
			model: {
				id: false,
				name: '',
                slug: '',
                status: 0,
                default: 0,
                plans: {
                    enabled: 0,
                    available: []
                }
			}
		}

	},

	validations: function() {

		return {
			model: {
				name: {
					required
				},
                plans: {}
			}

		}

	},

    computed: {

		joinURL: function() {

			return process.env.VUE_APP_JOIN

		},

		prefixURL: function() {

			return this.$organisation.slug + '/' + this.$membership.slug + '/'

		}
    
    }

}

</script>

<style scoped>

</style>